export const isIosWebView = (ua) => /iphone|ipod|ipad/.test(ua.toLowerCase());

export const isAndroidWebView = (ua) => ua.toLowerCase().includes('android');

export const isFacebookWebView = (ua) => /fbav|fbios/.test(ua.toLowerCase());

export const isInstagramWebView = (ua) =>
    ua.toLowerCase().includes('instagram');

export const isLinkedInWebView = (ua) =>
    ua.toLowerCase().includes('linkedinapp');

/*
 * When having an asynchronous payment such as Sofort or Bancontact, the checkout flow
 * relies on having a second tab where the user peforms the payment while the first one
 * stays idle on EB.
 * This two-tabs mechanics doesn't work for in-app browsers such as Facebook's, Instagram's
 * or LinkedIn on iOS as they simply do not support tabs. We therefore us an alternative flow
 * where EB's tab performs a redirection on demand by the user.
 * For more info on the implementation details, please refer to: EB-95856.
 *
 * This methods determine whether the first or the second flow should be followed.
 */
export const shouldPerformTablessCheckout = () => {
    const userAgent =
        window.navigator.userAgent || navigator.vendor || window.opera;
    const isOffendingAppWebView =
        isFacebookWebView(userAgent) ||
        isInstagramWebView(userAgent) ||
        isLinkedInWebView(userAgent);
    const isWebView = isIosWebView(userAgent) || isAndroidWebView(userAgent);

    return isOffendingAppWebView && isWebView;
};

export const isNativeApp = (state) =>
    Boolean(state.app.useIosProfile || state.app.useAndroidProfile);
